import { Modal } from '@design';
import React from 'react';

import styles from './PanesLimitModal.module.scss';

export interface PanesLimitModalLocales {
  title: string;
  message: string;
  closeButton: string;
}

interface PanesLimitModalProps {
  onClose: () => void;
  locales: PanesLimitModalLocales;
}

export const PanesLimitModal = ({ onClose, locales }: PanesLimitModalProps) => {
  return (
    <Modal
      className={styles.styledModal}
      data-testid="panes-limit-modal"
      isOpen
      title={locales.title}
      onClose={onClose}
      cancelBtnProps={{
        label: locales.closeButton,
        onClick: onClose,
      }}
    >
      <p className={styles.text}>{locales.message}</p>
    </Modal>
  );
};
